(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["digital-invoice-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-invoice-consent]');
    const form = root?.closest('form');
    if (!form || form.dataset.invoiceConsentBound) return;
    form.dataset.invoiceConsentBound = 'true';
    const checkbox = root.querySelector('[data-invoice-opt-in]');
    const values = Object.fromEntries([...form.querySelectorAll('[data-invoice-value]')].map(input => [input.dataset.invoiceValue, input]));
    const clear = () => { Object.values(values).forEach(input => { input.value = ''; }); };
    const reset = () => { checkbox.checked = false; clear(); };
    reset();
    root.hidden = false;
    window.addEventListener('pageshow', reset);
    checkbox.addEventListener('change', clear);
    form.addEventListener('submit', event => {
      clear();
      if (!checkbox.checked || (event.submitter && event.submitter.name !== 'checkout')) return;
      values.accepted.value = 'yes';
      values.version.value = root.dataset.consentVersion;
      values.digest.value = root.dataset.consentDigest;
      values.at.value = new Date().toISOString();
      values.binding.value = root.dataset.recipientBinding;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["launch-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const check = () => document.querySelectorAll('[data-bb-offer-end]').forEach((offer) => {
      const end = Date.parse(offer.dataset.bbOfferEnd);
      if (!Number.isFinite(end) || Date.now() >= end) offer.hidden = true;
    });
    check();
    window.addEventListener('pageshow', check);
    document.addEventListener('visibilitychange', check);
    window.setInterval(check, 60000);
  })();
  } catch(e) { console.error(e); }
})();

})();
